"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utilities = require("../utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dropdown = _styledComponents.default.div.attrs({
  "data-qa": "dropdown"
}).withConfig({
  displayName: "DropdownContent__Dropdown",
  componentId: "tzanro-0"
})(["background-color:", ";display:none;box-shadow:3px 2px 31px 1px rgba(", ",0.33);position:absolute;top:35px;z-index:1;@supports (filter:blur()){box-shadow:none;filter:drop-shadow(3px 2px 8px rgba(", ",0.33));}&:before{content:\"\";display:block;height:25px;position:absolute;top:-25px;width:100%;}&:after{top:-20px;right:10px;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none;border-bottom-color:", ";border-width:10px;}"], function (props) {
  return props.theme.carvana.white.primary;
}, function (props) {
  return (0, _utilities.HexToRgb)(props.theme.carvana.blue.dark);
}, function (props) {
  return (0, _utilities.HexToRgb)(props.theme.carvana.blue.dark);
}, function (props) {
  return props.theme.carvana.white.primary;
});

var DropdownContent = function DropdownContent(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return _react.default.createElement(Dropdown, {
    className: className,
    "data-qa": "dropdown-content"
  }, children);
};

DropdownContent.defaultProps = {
  children: null,
  className: ''
};
var _default = DropdownContent;
exports.default = _default;
module.exports = exports.default;